var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('LoadingIndicator'),_c('router-view'),(_vm.showDevBar)?_c('DevNavBar',{attrs:{"menu-items":_vm.devNavItems}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }